import { PublicClientApplication, type Configuration } from '@azure/msal-browser'

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID}`,
    // Use window.location.origin for portability across environments (local,
    // SWA preview, production). The Entra app registration must list this
    // origin as a redirect URI — a trailing-slash mismatch causes AADSTS50011.
    redirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage: tokens survive a page reload but not a closed tab.
    // This is the approved posture per the reconciled spec.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: false,
  },
}

// Single PCA instance shared across the app. Created at module load so
// handleRedirectPromise can be called before any rendering happens.
export const msalInstance = new PublicClientApplication(msalConfig)

// The scope that acquires whatever App Roles the signed-in user has on the
// API registration. Server-side authorisation uses the `roles` claim.
export const API_SCOPES = [`${import.meta.env.VITE_API_AUDIENCE}/.default`]
